import { render } from "./Join.vue?vue&type=template&id=d2d3ae62"
import script from "./Join.vue?vue&type=script&lang=js"
export * from "./Join.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__